import { withInstall, withNoopInstall } from '@jdesign-vue/utils'
import Avatar from './src/avatar.vue'
import AvatarGroup from './src/avatar-group.vue'

export const JdAvatar = withInstall(Avatar, {
  AvatarGroup,
})
export const JdAvatarGroup = withNoopInstall(AvatarGroup)
export default JdAvatar

export * from './src/avatar'
export type { AvatarInstance, AvatarGroupInstance } from './src/instance'
